var _circle, _linearGradient, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner",
    width: "174px",
    height: "174px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    fill: "transparent",
    strokeWidth: 2,
    cx: 33,
    cy: 33,
    r: 30,
    stroke: "url(#gradient)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "currentColor",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "currentColor",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner-dot dot",
    width: "10px",
    height: "10px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    x: 37,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 10,
    cx: 33,
    cy: 33,
    r: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.97f1587d2915ae0529d67027bfcb6772.svg";
export { ForwardRef as ReactComponent };